<template>
    <div
        class="md-cta layout3 mg-bg"
        :class="{ 'mg-container': !fullColumn }"
        :style="{
            ...spaceStyle,
            ...colorStyle
        }"
    >
        <site-title :title="title" class="f-col" v-animated="{name: 'shift-right', enable: showAnimationEffects}" />
        <div
            ref="content"
            class="content-box"
            :class="{
                'mobile-no-margin': mobileNoMargin
            }"
            :style="{ minHeight: minHeight }"
        >
            <div class="content">
                <div class="content-img">
                    <template v-if="col1PictureSrc">
                        <site-img :src="col1PictureSrc" />
                        <div
                            v-if="maskOption.showMask"
                            class="image-mask"
                            :style="maskColor"
                        ></div>
                    </template>
                    <div v-else class="defalt-wrap col1-default">
                        <site-img :src="defaultImgSrc" dir="width" />
                    </div>
                </div>
                <div class="cta-content f-col-2" :class="col1Align" v-animated="{name: isMobile ? 'shift-right' : 'shift-left', enable: showAnimationEffects}">
                    <site-title
                        :title="col1Title"
                        :size="24"
                        :mbSize="20"
                        :align="col1Align"
                    />
                    <site-sub-title
                        :title="col1SubTitle"
                        :size="14"
                        :mbSize="14"
                        :align="col1Align"
                    />
                    <banner-button
                        :buttons="col1Buttons"
                        @callback="showRegisterPop"
                        @scrollTo="scrollToAnchor"
                        :showArrow="showArrow"
                    />
                </div>
            </div>
            <div class="content">
                <div class="content-img">
                    <template v-if="col2PictureSrc">
                        <site-img :src="col2PictureSrc" />
                        <div
                            v-if="maskOption.showMask"
                            class="image-mask"
                            :style="maskColor"
                        ></div>
                    </template>
                    <div v-else class="defalt-wrap col2-default">
                        <site-img :src="defaultImgSrc" dir="width" />
                    </div>
                </div>
                <div class="cta-content f-col-2" :class="col2Align" v-animated="{name: 'shift-right', enable: showAnimationEffects}">
                    <site-title
                        :title="col2Title"
                        :size="24"
                        :mbSize="20"
                        :align="col2Align"
                    />
                    <site-sub-title
                        :title="col2SubTitle"
                        :size="14"
                        :mbSize="14"
                        :align="col2Align"
                    />
                    <banner-button
                        :buttons="col2Buttons"
                        @callback="showRegisterPop"
                        @scrollTo="scrollToAnchor"
                        :showArrow="showArrow"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import common from '../index';
export default {
    mixins: [common],
    data: function() {
        return {
            title: '',
            showArrow: false
        };
    },
    computed: {
        maskColor({ maskOption }) {
            return maskOption && maskOption.showMask && maskOption.maskColor && {
                backgroundColor: maskOption.maskColor
            }
        }
    }
};
</script>
<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';

.md-cta.layout3 {
    >.site-title {
        padding-bottom: 40px;
        padding-top: 80px;
        @include media-600 {
            padding-bottom: 20px;
            padding-top: 40px;
        }
    }
    .content-box {
        padding: 0;
        position: relative;
    }
    .content {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        .content-img {
            width: 50%;
            flex-grow: 0;
            flex-shrink: 0;
            position: relative;
            img{
                display: block;
                object-fit: cover;
                width: 100%;
                @include media-min-600 {
                    min-height: 500px;
                    aspect-ratio: 720 / 500;
                }
            }
            .image-mask{
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
            }
            .defalt-wrap {
                width: 100%;
                height: 500px;
                background: rgba(218, 218, 218, 0.2);
                display: flex;
                justify-content: center;
                align-items: center; 
                @include media-600 {
                    height: 260px;
                }
                img {
                    width: 100px;
                    height: 87.5px;
                    object-fit: contain;
                    opacity: 0.3;
                    @include media-600 {
                        width: 50px;
                        height: 44px;
                    }
                }
            }
        }
        .cta-content{
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: 20px 0 20px 50px;
            height: 500px;
            &.left{
                align-items: flex-start;
            }
            &.center{
                align-items: center;
            }
            &.right{
                align-items: flex-end;
            }
            .site-title{
                margin-bottom: 13px;
            }
            .site-subtitle {
                max-height: 100%;
                overflow-y: auto;
                padding-bottom: 1px;
                &::-webkit-scrollbar {
                    width: 6px;
                }
                &::-webkit-scrollbar-track {
                    background: transparent;
                    border-radius: 6px;
                }
                &::-webkit-scrollbar-thumb {
                    border-radius: 6px;
                    position: relative;
                    display: block;
                    width: 0;
                    height: 0;
                    cursor: pointer;
                    background-color: rgba(144, 147, 153, 0.3);
                    -webkit-transition: 0.3s background-color;
                    transition: 0.3s background-color;
                }
            }
            .banner-button-v2 {
                width: auto;
                margin-top: 30px;
            }
            .banner-button-v2 .btn-item{
                margin: 0;
                min-width: 150px;
                font-size: 16px;
                height: 50px;
                line-height: 50px;
            }
            .banner-button-v2 .btn-item+.btn-item{
                margin-left: 20px;
            }
            @include media-600 {
                >*{
                    padding: 0 15px;
                }
                .site-title{
                    margin-bottom: 10px;
                }
                .banner-button-v2 {
                    margin-top: 15px;
                }
            }
        }
        @include media-min-600 {
            &:nth-child(even) {
                flex-direction: row-reverse;
                .cta-content{
                    padding: 20px 50px 20px 0;
                }
            }
        }
    }
    @include media-600{
        .content{
            flex-direction: column;
            .content-img {
                width: 100%;
                img{
                    min-height: 260px;
                    aspect-ratio: 375 / 260;
                }
            }
            .cta-content{
                padding: 20px 0 30px 0;
                height: auto;
            }
        }
    }
}
</style>
